import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function StarOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_232)'>
        <path
          d='M17.5598 21C17.3998 21.0007 17.2421 20.9629 17.0998 20.89L11.9998 18.22L6.89976 20.89C6.73416 20.9771 6.54744 21.016 6.36084 21.0022C6.17424 20.9885 5.99524 20.9226 5.84419 20.8122C5.69314 20.7018 5.5761 20.5512 5.50638 20.3776C5.43665 20.204 5.41704 20.0142 5.44976 19.83L6.44976 14.2L2.32976 10.2C2.20122 10.0717 2.11003 9.91089 2.06599 9.73471C2.02195 9.55854 2.02671 9.3737 2.07976 9.20002C2.13772 9.0223 2.24434 8.86437 2.38751 8.74418C2.53069 8.62398 2.70469 8.54633 2.88976 8.52002L8.58976 7.69002L11.0998 2.56002C11.1816 2.39095 11.3095 2.24836 11.4687 2.14859C11.6278 2.04883 11.8119 1.99591 11.9998 1.99591C12.1876 1.99591 12.3717 2.04883 12.5309 2.14859C12.69 2.24836 12.8179 2.39095 12.8998 2.56002L15.4398 7.68002L21.1398 8.51002C21.3248 8.53633 21.4988 8.61398 21.642 8.73418C21.7852 8.85437 21.8918 9.0123 21.9498 9.19002C22.0028 9.3637 22.0076 9.54854 21.9635 9.72471C21.9195 9.90089 21.8283 10.0617 21.6998 10.19L17.5798 14.19L18.5798 19.82C18.6155 20.0075 18.5968 20.2013 18.5259 20.3785C18.455 20.5557 18.3349 20.7089 18.1798 20.82C17.9987 20.9469 17.7806 21.0102 17.5598 21ZM11.9998 16.1C12.1601 16.096 12.3186 16.1339 12.4598 16.21L16.2298 18.21L15.5098 14C15.4818 13.8393 15.4936 13.6741 15.5442 13.519C15.5947 13.3639 15.6825 13.2235 15.7998 13.11L18.7998 10.18L14.5998 9.56002C14.4457 9.52901 14.3012 9.46215 14.1778 9.36486C14.0545 9.26756 13.9558 9.14257 13.8898 9.00002L11.9998 5.25002L10.1098 9.00002C10.0374 9.14372 9.93145 9.26785 9.80089 9.36186C9.67032 9.45587 9.51899 9.51698 9.35976 9.54002L5.15976 10.16L8.15976 13.09C8.27704 13.2035 8.36478 13.3439 8.41533 13.499C8.46588 13.6541 8.4777 13.8193 8.44976 13.98L7.72976 18.14L11.4998 16.14C11.6595 16.0806 11.8326 16.0668 11.9998 16.1Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_232'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
